const tv_bp_chart_options = ({
    data
}) => ({
    title: {
        text: "",
        align: "left"
    },
    subtitle: {
        text: "",
        align: "left"
    },
    chart: {
        zoomType: "x",
        type: "boxplot",
        panKey: "alt",
        panning: true,
        borderRadius: 8,
    },
    xAxis: {
        type: "datetime",
        ordinal: false,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        scrollbar: {
            enabled: false
        },
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        },
    },
    yAxis: {
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        },
    },
    series: [
        {
            name: "Blood Pressure",
            showInLegend: false,
            color: '#053D6E',
            stemWidth: 2,
            whiskerWidth: 2,
            whiskerLength: 12,
            pointRange: 0,
            pointWidth: 0,
            data: data.boxplot
        },
        {
            name: "Blood Pressure",
            showInLegend: false,
            marker: {
                enabled: true,
                radius: 3
            },
            dashStyle: 'dot',
            color: '#053D6E',
            type: 'line',
            data: data.median,
        }
    ],
    labels: {
        overflow: "scroll"
    },
    navigator: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    plotOptions: {
        line: {
            marker: {
                enabled: false
            }
        },
    },
    exporting: {
        enabled: true
    }
});

export default tv_bp_chart_options;
